import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hotjar",
  "use": "hotjar-usage",
  "viewBox": "0 0 30 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 32\" id=\"hotjar\"><path d=\"M20.177 31.102c2.36-8.477 1.514-12.747-2.632-13.572.637 2.881 1.347 5.836-1.68 7.83-1.588 1.044-2.84.647-5.649-1.514C8.921 26.51 9.36 29.16 9.956 32c-4.03-.7-7.205-2.37-8.676-6.264A9.25 9.25 0 013.367 15.42 25.682 25.682 0 016.5 12.716C11.031 9.313 11.908 6.014 9.517.898A6.963 6.963 0 019.257 0 30.36 30.36 0 0123.11 5.878c8.833 7.225 7.769 20.202-1.983 24.974-.33.025-.652.11-.95.25z\" fill=\"#EE4854\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol